<script>
import abstractField from '../abstractField';
import { h, resolveComponent } from 'vue';

export default {
  name: 'field-input',
  mixins: [abstractField],
  computed: {},
  methods: {
    onInput(val) {
      this.value = val;
    },
    onChange(val) {
      this.schema.onChange || null;
    },
    onBlur() {}
  },
  render() {
    const legoTextField = resolveComponent('lego-text-field');
    return h(legoTextField, {
      modelValue: this.value,
      id: this.schema.id,
      rules: this.schema.validate,
      textarea: this.schema.textarea,
      class: this.schema.fieldClasses,
      disabled: this.schema.disabled,
      clearable: !(this.schema.textarea || this.schema.readonly) || false,
      counter: this.schema.maxlength,
      isCounter: this.schema.counter || false,
      multiple: this.schema.multiple,
      name: this.schema.inputName,
      lazy: this.schema.lazy,
      placeholder: this.schema.placeholder,
      readonly: this.schema.readonly,
      required: this.schema.required,
      rows: this.schema.rows,
      width: this.schema.width,
      messageStyle: 'light',
      errorMsg: this.schema.errorMsg,
      'onUpdate:modelValue': this.onInput,
      onBlur: this.onBlur,
      onChange: this.onChange
    });
  }
};
</script>

<style lang="scss" scoped></style>
